import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const MAX_POLLS = 8;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking"); // checking | success | pending | error
  const polls = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { await refresh(); setState("success"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
        if (polls.current >= MAX_POLLS) { setState("pending"); return; }
        polls.current += 1;
        timer = setTimeout(poll, 2000);
      } catch { setState("error"); }
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refresh]);

  const config = {
    checking: { icon: <Loader2 className="h-14 w-14 text-primary animate-spin" />, title: "Verifica del pagamento...", text: "Attendere qualche secondo." },
    success: { icon: <CheckCircle2 className="h-14 w-14 text-success" />, title: "Pagamento completato!", text: "I tuoi vantaggi sono stati attivati." },
    pending: { icon: <Loader2 className="h-14 w-14 text-[hsl(var(--gold))]" />, title: "Pagamento in elaborazione", text: "Aggiorneremo il tuo account appena confermato." },
    error: { icon: <XCircle className="h-14 w-14 text-destructive" />, title: "Pagamento non riuscito", text: "Nessun addebito effettuato. Riprova." },
  }[state];

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="max-w-md w-full text-center rounded-2xl bg-card border border-border/60 tactile-shadow p-10" data-testid={`payment-${state}`}>
        <div className="flex justify-center">{config.icon}</div>
        <h1 className="font-head font-extrabold text-2xl mt-6">{config.title}</h1>
        <p className="text-muted-foreground mt-2">{config.text}</p>
        <Button className="rounded-full mt-8 w-full" onClick={() => navigate("/premium")} data-testid="payment-continue">Torna a Premium & Crediti</Button>
      </div>
    </div>
  );
}
